export default function() {
	function SelectCity(country, region, city, zip) {
		let params = $('.js-city-plugin__select-wrapper').data('params');

		$.post(
			params.save_url,
			Object.assign(
				{
					country: country,
					region: region,
					city: city,
					zip: zip,
					url: location.pathname
				}
			),
			function(response) {
				if (response.data.url) {
					if(response.data.env_key && response.data.restore_url) {
						var id = 'shop-city-plugin-' + response.data.uniqid;
						var url = response.data.restore_url;

						$('body').append('<img id="' + id + '" src="" style="display: none">');

						$('#' + id).on('error', function() {
							//console.log(response.data.url);
							location.href = response.data.url;
						});

						$('#' + id).attr('src', url);
					} else {
						location.href = response.data.url;
					}
				} else {
					location.reload();
				}
			},
			'json'
		);
	}

	window.ObserverUtil.observe('city-plugin-dialog', ($dialog) => {
		$dialog.find('.city-plugin-dialog__header-title').html('Выберите регион');

		$dialog.find('.city-plugin-dialog__return-button').on('click', () => {
			window.shop_city_plugin_dialog('close');
		});

		$('.js-city-plugin-form__dropdown').empty();

		$dialog.find('.popular-cities__item').on('click', function(){
			const country = $(this).data('country');
			const region = $(this).data('region');
			const city = $(this).data('city');
			const zip = $(this).data('zip');

			const $dialog = $(this).closest('.js-city-plugin__dialog');
			const is_custom_handler = $dialog.data('custom-handler') == 1;
			const custom_handler_id = $dialog.data('custom-handler-id');

			if (is_custom_handler) {
				$(document).trigger(custom_handler_id, [{
					country: country,
					region: region,
					city: city,
					zip: zip
				}]);
			} else {
				SelectCity(country, region, city, zip);
			}
		});

		const $searchField = $dialog.find('.city-plugin-form__search-field');

		$dialog.find('.popular-cities__countries-item').on('click', function () {
			$searchField.attr('data-search_country_iso3', this.dataset.jsTab);
			$searchField.val('');
			$searchField.trigger('keyup');
		})

	})
}
